export default {
  path: '/exam/answer',
  component: (r) => require(['@/v3/modules/card_use/views/student-answer/components/layout'], r),
  meta: { auth: ['Answer', 'Region-Exam-Answer'], checkAuth: true },
  children: [
    {
      path: '/exam/answer/student-answer/:id',
      name: 'StudentAnswer',
      component: (r) => require(['@/v3/modules/card_use/views/student-answer/studentAnswer'], r),
      meta: { auth: ['Answer-Sheet-Scan', 'Region-Exam-Single'], checkAuth: true, moreAuths: ['exam'] }
    },
    {
      path: '/exam/answer/scan-batch/:id',
      name: 'ExamScanBatch',
      component: (r) => require(['@/v3/modules/card_use/views/student-answer/scanBatch'], r)
    },
    {
      path: '/exam/answer/batch-doubt/:id',
      name: 'ExamBatchDoubt',
      component: (r) => require(['@/v3/modules/card_use/views/student-answer/batchDoubtView'], r)
    }, {
      path: '/exam/answer/student-view/:id',
      name: 'StudentView',
      component: (r) => require(['@/v3/modules/card_use/views/student-answer/studentView'], r)
    }
  ]
}
